// extracted by mini-css-extract-plugin
export default {"pageManager":"PageManager-module__pageManager___ir5PJ"};